export class PreviewIngestionPipelineUpdateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diffAvailable",
            "baseName": "diffAvailable",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "before",
            "baseName": "before",
            "type": "Array<PipelineHistoryField>",
            "format": ""
        },
        {
            "name": "after",
            "baseName": "after",
            "type": "Array<PipelineHistoryField>",
            "format": ""
        },
        {
            "name": "changes",
            "baseName": "changes",
            "type": "Array<PipelineHistoryFieldChange>",
            "format": ""
        },
        {
            "name": "hasUnlistedChanges",
            "baseName": "hasUnlistedChanges",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PreviewIngestionPipelineUpdateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
